import type { AuthTokens } from '@/libs/token-manager';
import api from '@/libs/axiosInstance';
import { useMutation } from '@tanstack/react-query';
import type { AcceptBrandSignupInvitationResponse, ApiResponse } from '@fluenceur/types';
import { storeBrandSessionTokens } from './brand-session-tokens';

export interface AcceptBrandSignupInvitationRequest {
  token: string;
  email: string;
  firstName: string;
  lastName: string;
  password: string;
}

const acceptBrandSignupInvitationRequest = async (
  data: AcceptBrandSignupInvitationRequest
): Promise<AuthTokens> => {
  const { token, ...body } = data;
  const { data: response } = await api.post<ApiResponse<AcceptBrandSignupInvitationResponse>>(
    `/brand-signup/invitations/${token}/accept`,
    body
  );

  if (!response.success || !response.data) {
    throw new Error(response.message || 'Failed to accept brand signup invitation');
  }

  return storeBrandSessionTokens(response.data.token);
};

export const useAcceptBrandSignupInvitationAction = () =>
  useMutation<AuthTokens, Error, AcceptBrandSignupInvitationRequest>({
    mutationFn: acceptBrandSignupInvitationRequest,
  });
